import EditAttribute from './EditAttribute'

export default EditAttribute
